import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useNavigate } from "react-router-dom";

function Login() {

    const [email, setemail] = useState()
    const [password, setPassword] = useState()


    let navigate = useNavigate()

    
    function checkStorage() {
        if (email===localStorage.getItem('email') && password===localStorage.getItem('password')) {
            sessionStorage.setItem('login','IsLogin')
            alert('로그인에 성공하였습니다.'+ sessionStorage.getItem('login'))           
        } else {
            alert('아이디나 비밀번호가 틀렸습니다.')
        }
    }

    return (
        <div 
        style={{display:'flex', justifyContent:'center',
        height:'100%', alignItems:'center', marginTop:'200px'}}>
             <Form style={{width:'350px'}}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" placeholder="Enter email"
                    
                    onChange={(e)=>{setemail(e.target.value)
                        console.log(email)}}

                    />
                    <Form.Text className="text-muted">
                    </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" placeholder="Password"
                     onChange={(e)=>{
                        setPassword(e.target.value)
                        console.log(password)
                     }} />                    
                </Form.Group>              
                <Button variant="dark" style={{float:'Right'}}
                onClick={()=>{
                    checkStorage()                    
                    navigate('/')     
                    }}>
                    로그인
                </Button>
            </Form>
        </div>
    )

}

export default Login